module.exports = __webpack_public_path__ + "img/baby.ac948fe4.png";